// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RWPP","controls":"styles_controls__a4jt0","charLimit":"styles_charLimit__1JT7x","input":"styles_input__IYvUM","send":"styles_send__1YmRe"};